import * as Helper from './helpers.mjs';

class Form {
    constructor($form, config) {
        this.form = $form;

        this.config = $.extend({}, {
            submitUrl: false,
            action : false,
        }, config);

        this.id = $form.data('id') ? $form.data('id') : $('form').first().attr('data-id');
        
        if (!this.id) {
            this.id = 0;
        }
        
        //super.init();
        
        //KEEP THESE THEY MIGHT ME NEEDED
        // this.form.on('change', '.required', $.proxy(this.onChangeRequired, this));
        // this.form.on('click', '.checkbox', $.proxy(this.onClickCheckbox, this));
    }

    initDatePicker(allowDatesInPast = true){
        // var dateInputs = this.form.find("input[type=date]");
        var dateInputs = document.querySelectorAll(".form-date");
        var action = Helper.getPageInfo("action");
        var _this = this;

        var defaults = {
            firstDay: 1,
            format: 'DD/MM/YYYY',
            maxDate: new Date(2030, 12, 31),
            yearRange: [2000,2030],
            gotoTodayButton: true,
            isParsed: false,
            toString(date, format) {
                // you should do formatting based on the passed format,
                // but we will just return 'D/M/YYYY' for simplicity
                const day = date.getDate();
                const zeroDay = day < 10 ? ("0" + day) : day;
                const month = date.getMonth() + 1;
                const zeroMonth = month < 10 ? ("0" + month) : month;
                const year = date.getFullYear();
                return `${zeroDay}/${zeroMonth}/${year}`;
            },
            parse(dateString, format) {
                // dateString is the result of `toString` method
                const parts = dateString.split('/');
                const day = parseInt(parts[0], 10);
                const month = parseInt(parts[1], 10) - 1;
                const year = parseInt(parts[2], 10);
                return new Date(year, month, day);
            },
            onDraw: function(date){
                const buttonMenu =  document.createElement("menu");
                const todayButton = document.createElement("button");
                const tomorrowButton = document.createElement("button");
                const resetButton = document.createElement("button");
                todayButton.classList.add("btn", "btn-primary", "btn-sm", "btn-today");
                tomorrowButton.classList.add("btn", "btn-light", "btn-sm", "btn-tomorrow");
                resetButton.classList.add("btn", "btn-light", "btn-sm", "btn-reset");
                todayButton.textContent = "today";
                tomorrowButton.textContent = "tomorrow";
                resetButton.textContent = "reset";
                buttonMenu.appendChild(todayButton);
                buttonMenu.appendChild(tomorrowButton);
                buttonMenu.appendChild(resetButton);
                var _this = this;
            }
        }   

        if(dateInputs.length){
            dateInputs.forEach(function (element) {
                if (element.classList.contains("pikadayInit")) {
                    return false;
                };
                element.classList.add("pikadayInit");
                let id = element.id;
                let minDate = false;
                element.setAttribute("type", "text");
                let dateString = element.value;
                let hasMinDate = typeof element.dataset.minDate === "undefined" ? false : element.dataset.minDate;

                if(action != "edit"){
                    minDate = _this.setMinDate(hasMinDate);
                };
                var options = Object.assign({
                    field: element,
                    minDate: minDate,
                    id: id,
                    //container: document.querySelector(".pikaday-container." + elementNameClass)
                }, defaults);
                var picker = window['picker' + id.charAt(0).toUpperCase() + id.slice(1)] 
                picker = new Pikaday(options);
                //picker.gotoDate(new Date(2014, 1))
                let lastSavedValue = element.getAttribute("value");
                if(lastSavedValue){
                    let parts = lastSavedValue.split('/');
                    let day = parseInt(parts[0], 10);
                    let zeroDay = day < 10 ? ("0" + day) : day;
                    let month = parseInt(parts[1], 10);
                    let zeroMonth = month < 10 ? ("0" + month) : month;
                    let year = parseInt(parts[2], 10);
                    picker.setDate(`${year}-${zeroMonth}-${zeroDay}`);
                }

                picker.el.addEventListener("click", function(event){

                    var input = picker._o.field;
                    var today = new Date();
                    var tomorrow = new Date();
                    tomorrow.setDate(tomorrow.getDate() + 1);
                    
                    
                    if(event.target.classList.contains("btn-today")){
                        
                        input.value = today.toLocaleDateString('en-GB');
                        // input.defaultValue = picker._o.toUTCString(today);
                        picker.hide();
                    }
                    if(event.target.classList.contains("btn-tomorrow")){

                        input.value = tomorrow.toLocaleDateString('en-GB');
                        // input.defaultValue = picker._o.toUTCString(tomorrow);
                        picker.hide();
                    }
                    if(event.target.classList.contains("btn-reset")){
                        input.value = "";
                        input.defaultValue = "";
                        picker.hide();
                    }
                });
                picker.hide();
            })            
        }
    }

    setMinDate(minDateAttr){
        let result = false;
        const today = new Date();
        const tomorrow = new Date(today);
        tomorrow.setDate(tomorrow.getDate() + 1);

        if(minDateAttr === false){
            result = false;
        } else if(minDateAttr === "1"){
            result = today;
        } else if(minDateAttr === "today"){
            result = today;
        } else if(minDateAttr === "tomorrow"){
            result = tomorrow;
        } else if(minDateAttr !== (false | "1" | "today" | "tomorrow") && validator.isDate(minDateAttr, 'YYYY-MM-DD')){
            let parts = minDateAttr.split('-');
            let day = parseInt(parts[2], 10);
            let month = parseInt(parts[1], 10) - 1;
            let year = parseInt(parts[0], 10);
            result = new Date(year, month, day);
        } else{
            result = false;
        }

        return result;
    }

    checkDuplicate(name, currentId) {
        var section = Helper.getPageInfo('sectionPath');
        var url = '/weave/' + section + '/checkDuplicate/' + currentId;
        const formData = new FormData();
        formData.append('name', name);

        return fetch(url, {
            method: 'POST',
            body: formData
        }).then(r=>r.json());
    }

    // Accepts either an nodelist, array of selectors, or jquery collection 
    async validateForm(formInputs = false) {
        var valid = true;
        var _this = this;
        //var $formInputs;

        if(Array.isArray(formInputs)){
            formInputs = document.querySelectorAll(formInputs.toString());  
        }
        // if nodelist
        if(NodeList.prototype.isPrototypeOf(formInputs)){
            formInputs = $(formInputs);
        }

        if(!formInputs){
            formInputs = this.form.find("[required]:visible");
        }
        
        //this.toggleFormError(valid);
        formInputs.each(function(){

            if ($(this).hasClass("skip-validation")) {
                $(this).parents(".form-group").removeClass("has-error");
                $(this).removeClass('shake animated');
                return;
            }
            if (!$(this).hasClass("form-select") && $(this).val()) {
                $(this).parents(".form-group").removeClass("has-error");
                $(this).removeClass('shake animated');
                return;
            }

            if ($(this).hasClass("form-select") && $(this).val() != "none") {
                $(this).parents(".form-group").removeClass("has-error");
                $(this).removeClass('shake animated');
                return;
            }

            _this.toggleInputError(this);

            valid = false;
        });

        // validate dates
        formInputs.each(function(){
            if ($(this).hasClass("form-date") && $(this).val() && !$(this).hasClass("skip-validation")) {
                var date = Helper.parseUKDate($(this).val()).toUTCString();
                if (date === "") {
                    _this.toggleInputError(this, "Please enter a date in the format dd/mm/yyyy");
                    valid = false;
                    return;
                }
            }
        });

        if (this.config.checkForDuplicateNames) {
            // check for duplicate names
            var $name = this.form.find('#' + this.config.checkForDuplicateNames);
            
            var duplicate = await this.checkDuplicate($name.val(), this.id);
            
            if (duplicate.error) {
                this.toggleInputError($name[0], "This name is already in use");
                valid = false;
            }
        }

        // check standard html validity
        formInputs.each(function(){
            if (!$(this)[0].checkValidity()) {
                valid = false;
            }
        });

        return valid;
    }

    toggleInputError(input, message = false){
        if(message){
            var $inputHint = $(input).closest(".form-group").find(".form-input-hint");
            if($inputHint.hasClass("tooltip")){
                $inputHint.attr("data-tooltip", message);
            }else{
                $inputHint.html(message);
            }
        }
        $(input).addClass('shake animated');
        $(input).parents(".form-group").first().addClass("has-error");
        $(input).one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
            $(input).removeClass('shake animated');
        });
    }

    toggleFormError(isValid, _this){
        var formErrorBlock;
        if(_this.form instanceof jQuery){
            formErrorBlock = _this.form.find('.toast-error.form-error');
        }else{
            formErrorBlock = $(_this.form).find('.toast-error.form-error');
        }

        if(isValid){
            formErrorBlock.hide()
        }else{
            formErrorBlock.show();
            $(window).scrollTop(0);
        }
    }

    replaceHtml(html) {
        this.form.html($(html).find('form').html());
    }

    submitForm() {
        this.form.submit();
    }

    async onSubmit(e) {
        e.preventDefault();
        var valid = await this.validateForm();
        this.toggleFormError(valid, this);

        if (!valid) {
            return false;
        }

        this.submitForm();
    }

    onChangeRequired(e) {
        if ($(e.target).val()) {
            $(e.target).addClass('shake animated');
            $(e.target).parents(".form-group").addClass("has-error");
        }
    }

    // getSelectedRowIds(){
    //     let checkboxes = document.querySelectorAll("[id^=selectRow]:checked");
    //     let rows = [];
    //     Array.prototype.forEach.call(checkboxes, (checkbox, index) => {
    //         rows.push(checkbox.parentNode.parentElement.parentNode.dataset.id);
    //     });
    //     return rows;
    // }

    // getSelectedRowNames(){
    //     let checkboxes = document.querySelectorAll("[id^=selectRow]:checked");
    //     let rows = [];
    //     Array.prototype.forEach.call(checkboxes, (checkbox, index) => {
    //         if (checkbox.parentNode.parentElement.parentNode.dataset.name) {
    //             rows.push(checkbox.parentNode.parentElement.parentNode.dataset.name);
    //         } else {
    //             rows.push(checkbox.parentNode.parentElement.parentNode.dataset.id);
    //         }
    //     });
    //     return rows;
    // }

    getSelectedRowIds(field, values) {
        if(typeof field == "undefined"){
            field = false;
        }
        if(typeof values == "undefined"){
            values = false;
        }
        let checkboxes = this.form[0].querySelectorAll("[id^=selectRow]:checked");
        let rows = [];
        Array.prototype.forEach.call(checkboxes, (checkbox, index) => {

            let row = checkbox.closest("tr");
            if(field == false || values == false){
                rows.push(row.dataset.id);
            }

            if(field != false && Array.isArray(values)){
                values.forEach(function (value, index) {
                    if(row.getAttribute("data-" + field) == value){
                        rows.push(row.dataset.id);
                    }
                })
            }
        });
        return rows;
    }

    getSelectedRowNames(rowIds) {

        if(typeof rowIds == "undefined"){
            return false;
        }
        let itemType = Helper.getPageInfo("section");
        var _this = this;
        let names = [];
        rowIds.forEach(function(id, index){
            if (index >= _this.config.maxNames) return;
            let row = _this.container[0].querySelector("tr[data-id='" + id + "']");
            if (row.dataset.name) {
                names.push(row.dataset.name);
            } else {
                names.push(itemType + " (" + id  + ")");
            }            
        });

        var string = names.join(', ');
        if (rowIds.length > _this.config.maxNames) {
            string += ' and ' + (rowIds.length - _this.config.maxNames) + ' others';
        }
        return string;
    }


    initCheckboxAll(){
        let selectAllCheckboxes = document.querySelectorAll('#selectAll');
        if(selectAllCheckboxes != null ){
            Array.prototype.forEach.call(selectAllCheckboxes, function(allCheckbox, index){
                allCheckbox.addEventListener('click', function(event) {
                    let _event = event.target.checked;
                    let rowCheckboxes = document.querySelectorAll("[id^=selectRow]");
                    Array.prototype.forEach.call(rowCheckboxes , function(rowCheckbox, index){
                        if (_event) {
                            rowCheckbox.checked = true;
                        } else {
                            rowCheckbox.checked = false;
                        }
                    });
                });

            });   
        }
    }

    syncBudgetFields(e){
        // debugger;
        var percentRegex = /budgetPercent/g;
        var valueRegex = /budgetValue/g;
        var input = e.target;
        var otherInput;
        var newValue;
        var row = e.target.closest('.form-group');
        var weaveBudget = document.querySelector("input[name*=weaveBudget]").value;
 
        // Calculate percent from value
        if (valueRegex.test(input.name)) {
            if (input.value == "") {
                input.value = parseFloat(0).toFixed(2);
            } else {
                input.value = parseFloat(input.value).toFixed(2);
            }
            otherInput = row.querySelector('input[name*=budgetPercent]');
            newValue = (parseFloat(input.value) / parseFloat(weaveBudget) * 100);
        }
        if (percentRegex.test(input.name)) {
            if (input.value == "") { input.value = 0; }
            otherInput = row.querySelector('input[name*=budgetValue]');
            newValue = (parseFloat(input.value) /  100 * parseFloat(weaveBudget)).toFixed(2);
        }
 
        if (newValue != otherInput.value) {
            otherInput.value = newValue;
        }
    }

    onClickCheckboxLabel(e) {
        var id = $(e.target).attr('for');
        
        $("#" + id).parent().trigger('click');
    }

    saveCurrentValue() {
        $(this).data('oldVal', $(this).val());
    }

    init() {
        this.initCheckboxAll();
        this.initDatePicker();

        var button = this.form.find("button[type='submit']");
        if(button.length){
            this.form[0].addEventListener('submit', this.onSubmit.bind(this));
            //Helper.reattachEventListener(createBtn, 'click', this.create.bind(this))
        }
    }
}

export { Form };